// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

const getEmailSignInMethodsByEmail = async ({
    email,
}: {
    email: string,
}): Promise<string[]> => {
    const functions = getFunctions();
    const handleGetEmailSignInMethodsByEmail = httpsCallable<
        Record<string, string>,
        string[]
    >(
        functions,
        'getEmailSignInMethodsByEmail',
    );
    return handleGetEmailSignInMethodsByEmail({
        email,
    }).then((result) => {
        const methods = result.data;
        return Array.isArray(methods) ? methods : [];
    }).catch((err) => {
        throw err;
    });
};

export default getEmailSignInMethodsByEmail;
